import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PermissionEnum } from "src/app/models/auth0/permission.enum";
import { IPlaybookTemplateCard } from "src/app/models/templates/playbooks/playbookTemplateCard.interface";
import { LabelsProviderPipe } from "src/app/pipes/labels-provider/labels-provider.pipe";
import { PermissionsService } from "src/app/services/infra/permissionsService/permissions.service";

@Component({
    selector: "app-playbook-template-card",
    templateUrl: "./playbook-template-card.component.html",
    styleUrls: ["./playbook-template-card.component.scss"],
})
export class PlaybookTemplateCardComponent implements OnInit {
    @Input() public card: IPlaybookTemplateCard;
    @Output() public cardActionClick = new EventEmitter<string>();

    public hasPermisions: boolean;
    public tooltip: string;

    constructor(
        private _permissionsService: PermissionsService,
        private _labelProvider: LabelsProviderPipe,
    ) {}

    ngOnInit(): void {
        this.hasPermisions = this._permissionsService.hasPermissions(PermissionEnum.operator);
        this.tooltip = !this.hasPermisions ? this._labelProvider.transform("commonActions.operatorActionTooltip") : "";
    }

    public actionClicked(): void {
        this.cardActionClick.emit(this.card.actionData);
    }
}
